<!-- https://www.figma.com/design/K7vDg6el3Bz7MHUdlMREDj/Credit-Conversion-Statuses?node-id=2027-58&p=f&m=dev -->
<template>
  <CardLayout
    button-href="mailto:ulcourses@asu.edu"
    button-text="Contact support"
    title="Oops! We're having a technical issue."
    :body="cardBody"
    :button-data-layer-event="dataLayerEvent"
    :button-disabled="false"
  >
    <template #art>
      <ArtError />
    </template>
  </CardLayout>
</template>

<script>
import CardLayout from '../ui/CardLayout.vue';
import ArtError from './ArtError.vue';

export default {
  name: 'CardError',
  components: {
    CardLayout,
    ArtError
  },
  data() {
    return {
      /**
       * @type {import('../ui/card-body').CardBody}
       */
      cardBody: {
        blocks: [
          {
            lines: [
              `Something went wrong during the process. Please contact the support team at <a class="card-body-link" href="mailto:ulcourses@asu.edu">ulcourses@asu.edu</a>.`
            ]
          }
        ]
      }
    };
  },
  computed: {
    dataLayerEvent() {
      return {
        event: 'link',
        action: 'click',
        name: 'onclick',
        type: 'external link',
        region: 'main content',
        section: "oops! we're having a technical issue",
        text: 'contact support',
        component: 'error card'
      };
    }
  }
};
</script>
